import { render, staticRenderFns } from "./InjectionRates.vue?vue&type=template&id=3b6da935"
import script from "./InjectionRates.vue?vue&type=script&lang=ts"
export * from "./InjectionRates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports